
<div class="row mt-3">
    <div class="col">
        <div class="field mb-3 position-relative">
            <label>Address:</label>@if (!isKingslynn) {
<span class="required-asterik">*</span>
}
            <ejs-dropdownlist #address
                [placeholder]="'Address'"
                [dataSource]="details?.addressType === 'technician' && technicianAddresses || details?.addressType === 'onSite' && [onsiteAddress]"
                [allowFiltering]="true"
                [filterType]="'contains'"
                [fields]="{text: 'address', value: 'addressCode'}"
                [value]="$safeNavigationMigration(details?.addressCode)"
                [enabled]="status === statuses.open && details?.addressType === 'technician' && !isManager && !isCSA"
                (change)="onAddressChange($event)"
            ></ejs-dropdownlist>
            @if (validationApplied && !details.addressCode) {
<div class="field-error">Address is required</div>
}
            @if (details?.addressCode) {
<div class="address-area p-2">
                @if (details.addressName) {
<span class="address-name">{{details.addressName}}</span>
}<br/>
                <span class="address">{{details.address}}</span><br/>
                @if (details.city) {
<span class="address-city">{{details.city}}, </span>
}<span class="address-state"> {{details.state}} </span><span class="address-zip-code"> {{details.zipCode}}</span><br/>
                @if (details.country) {
<span class="address-country">{{details.country}}</span>
}
            </div>
}
        </div>
    </div>
    <div class="col">
        <div class="field mb-3 position-relative">
            <label>Shipment method: </label><span class="required-asterik">*</span>
            <ejs-dropdownlist #shipmentMethod
                [placeholder]="'Shipment Method'"
                [dataSource]="shipmentMethods"
                [allowFiltering]="true"
                [filterType]="'contains'"
                [fields]="{text: 'text', value: 'value'}"
                [value]="$safeNavigationMigration(details?.shipmentMethodCode)"
                [enabled]="status === statuses.open && !isManager && !isCSA"
                (change)="details.shipmentMethodCode = $event.itemData.value; details.shipmentMethodDescription = $event.itemData.text; tabUpdated.emit(details)"
            ></ejs-dropdownlist>
            @if (validationApplied && !details.shipmentMethodCode) {
<div class="field-error">Shipment Method is required</div>
}
        </div>
        <div class="w-100"></div>
        <div class="field mb-3">
            <ejs-radiobutton
                name="addressType"
                label="Use Technicians Address"
                value="technician"
                [(ngModel)]="checkType"
                [disabled]="status !== statuses.open || isManager || isCSA"
                (change)="details.addressType = $event.value; radioButtonChanged($event)"
            ></ejs-radiobutton>
        </div>
        @if (details?.serviceOrderId) {
<div class="field mb-3">
            <ejs-radiobutton
                name="addressType"
                label="Use On-site Address"
                value="onSite"
                [(ngModel)]="checkType"
                [disabled]="!details?.serviceOrderId || status !== statuses.open || isManager || isCSA"
                (change)="details.addressType = $event.value; radioButtonChanged($event)"
            ></ejs-radiobutton>
        </div>
}
    </div>
    <div class="col">
        @if (!isIsc && !isIscManager && !isIscSupervisor) {
<div class="field mb-3">
            <label>LN Warehouse Order:</label>
            <ejs-textbox
                placeholder="LN Warehouse Order ID"
                [value]="$safeNavigationMigration(details?.warehouseOrderLN)"
                [enabled]="false"
                (change)="details.warehouseOrderLN = $event.value; tabUpdated.emit(details)"
            ></ejs-textbox>
        </div>
}
        <div class="w-100"></div>
        @if (isIsc || isIscManager || isIscSupervisor) {
<div class="field mb-3">
            <label>Sales Order Id</label>
            <ejs-textbox
                placeholder="Sales Order Id"
                [value]="$safeNavigationMigration(details?.salesOrderId)"
                [enabled]="false"
                (change)="details.salesOrderId = $event.value; tabUpdated.emit(details)"
            ></ejs-textbox>
        </div>
}
    </div>
</div>
